import React from 'react';
import { HeaderGroup } from 'react-table';

interface ModalBasicTableHeaderProps {
  table: any;
  showFilters?: boolean;
  actions?: any;
}

const ModalBasicTableHeader: React.FC<ModalBasicTableHeaderProps> = ({
  table,
  showFilters,
  actions,
}) => {
  const { headerGroups, setFilters } = table;

  return (
    <thead className="bg-gray dark:bg-form-strokedark border-b-slate-50">
      {headerGroups.map((headerGroup: HeaderGroup) => (
        <React.Fragment key={headerGroup.getHeaderGroupProps().key}>
          {/* 🧾 Encabezado de columnas */}
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => {
              const isIndexColumn =
                column.id === 'id' || column.id === 'rowIndex';
              return (
                <th
                  {...column.getHeaderProps()}
                  scope="col"
                  className={`py-3 text-sm font-semibold text-gray-700 dark:text-gray-200 ${
                    isIndexColumn
                      ? 'w-[50px] px-2 text-center'
                      : 'px-4 text-left'
                  }`}
                >
                  {column.render('Header')}
                </th>
              );
            })}
            {actions && (
              <th
                scope="col"
                className="px-4 py-3 text-center text-sm font-semibold text-gray-700 dark:text-gray-200"
              >
                Acciones
              </th>
            )}
          </tr>

          {/* 🔍 Filtros debajo del encabezado (si están habilitados) */}
          {showFilters && (
            <tr className="bg-gray-50 dark:bg-gray-900">
              {headerGroup.headers.map((column: any) => {
                const isIndexColumn =
                  column.id === 'id' || column.id === 'rowIndex';
                return (
                  <th key={column.id} className="px-2 py-2">
                    <input
                      type="text"
                      placeholder={isIndexColumn ? '' : 'Buscar...'}
                      disabled={isIndexColumn}
                      className={`${
                        isIndexColumn ? 'max-w-[50px]' : 'w-full'
                      } rounded border border-stroke bg-white px-2 py-1 text-sm text-black focus:border-primary dark:border-form-strokedark dark:bg-form-input dark:text-white`}
                      onChange={(e) =>
                        setFilters((prev: any) => ({
                          ...prev,
                          [column.id]: e.target.value,
                        }))
                      }
                    />
                  </th>
                );
              })}
              {actions && <th className="px-2 py-2"></th>}
            </tr>
          )}
        </React.Fragment>
      ))}
    </thead>
  );
};

export default ModalBasicTableHeader;
